import React, { useState } from "react";
import API from "../services/api";

function UploadAd() {
  const [title, setTitle] = useState("");
  const [linkUrl, setLinkUrl] = useState("");
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();
    formData.append("title", title);
    if (linkUrl) {
      formData.append("link_url", linkUrl);
    }
    formData.append("image", file);

    try {
      await API.post("/ads/upload", formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      alert("Ad uploaded successfully!");
      setTitle("");
      setLinkUrl("");
      setFile(null);
    } catch (error) {
      console.error(error);
      alert(error.response?.data?.message || "Failed to upload Ad.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto bg-white p-8 rounded-lg shadow-sm border border-gray-200 mt-8">
      <h2 className="text-2xl font-bold text-gray-800 mb-6 border-b pb-3">Upload New Ad</h2>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-1">Ad Title</label>
          <input
            type="text"
            required
            value={title}
            placeholder="e.g. Summer Sale Campaign"
            className="w-full border border-gray-300 rounded px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>

        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-1">Link URL (Optional)</label>
          <input
            type="url"
            value={linkUrl}
            placeholder="e.g. https://example.com/shop"
            className="w-full border border-gray-300 rounded px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
            onChange={(e) => setLinkUrl(e.target.value)}
          />
          <p className="text-xs text-gray-500 mt-1">Where should users go when they click the ad?</p>
        </div>

        <div>
           <label className="block text-sm font-semibold text-gray-700 mb-1">Ad Image (JPG, PNG, WEBP, GIF)</label>
           <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:bg-gray-50 transition cursor-pointer relative">
             <input
               type="file"
               required
               accept="image/jpeg, image/png, image/webp, image/gif"
               className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
               onChange={(e) => setFile(e.target.files[0])}
             />
             <div className="text-gray-500">
                {file ? (
                  <span className="text-green-600 font-semibold">{file.name}</span>
                ) : (
                  <span>Drag and drop Ad Image here or <span className="text-blue-600">browse</span></span>
                )}
             </div>
           </div>
         </div>

        <button
          disabled={loading}
          className={`w-full text-white font-bold py-3 rounded uppercase tracking-wide transition ${loading ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'}`}
        >
          {loading ? 'Uploading...' : 'Publish Ad'}
        </button>
      </form>
    </div>
  );
}

export default UploadAd;
